import * as React from 'react';
import { SVGProps } from 'react';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/explicit-module-boundary-types
const SmileDialog = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m16.2 34.4-7 3.6v-6.4C4.8 28.4 2 23.8 2 18.4 2 9.4 10 2 20 2s18 7.2 18 16.4c0 9-8 16.4-18 16.4-1.2 0-2.6-.2-3.8-.4Z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M27.8 23.2c-4.4 4.4-11.4 4.4-15.8 0M16 13.2v2M24 13.2v2"
    />
  </svg>
);
export default SmileDialog;
